export default "__VITE_ASSET__Chc$DABL__"